export default class ImageSizeEnum {
    static get XS() {
        return 'xs';
    }
    static get SM() {
        return 'sm';
    }

    static get MD() {
        return 'md';
    }

    static get LG() {
        return 'lg';
    }

    static get XL() {
        return 'xl';
    }

    static get XXL() {
        return 'xxl';
    }

    static get options() {
        return {
            XS: this.XS,
            SM: this.SM,
            MD: this.MD,
            LG: this.LG,
            XL: this.XL,
            XXL: this.XXL
        };
    }

    static getFromLegacyFlags(isLarge, isBao) {
        if (isBao) return this.SM;
        return isLarge ? this.XL : this.XL;
    }
}
